export enum RepairStatuses {
  /**
   * Ожидание диагностики
   */
  DIAGNOSTICS_AWAITING = 'waiting_diagnostic',

  /**
   * Проведение диагностики
   */
  DIAGNOSTICS_IN_PROCESS = 'carrying_diagnostic',

  /**
   * Ожидание согласования
   */
  CONFIRMATIOIN_AWAITING = 'waiting_approval',

  /**
   * Ожидание ЗИП
   */
  COMPONENT_AWAITING = 'waiting_zip',

  /**
   * Ремонт
   */
  REPAIR_IN_PROCESS = 'repair',

  /**
   * Работы завершены
   */
  REPAIR_FINISHED = 'work_completed',

  /**
   * Отгружен из СЦ
   */
  DISPATCHED = 'shipped_sc',

  /**
   * Отменен
   */
  CANCELED = 'canceled',
}

export const RepairStatusesTranslate: Record<string, string> = {
  [RepairStatuses.DIAGNOSTICS_AWAITING]: 'Ожидание диагностики',
  [RepairStatuses.DIAGNOSTICS_IN_PROCESS]: 'Проведение диагностики',
  [RepairStatuses.COMPONENT_AWAITING]: 'Ожидание ЗИП',
  [RepairStatuses.REPAIR_IN_PROCESS]: 'Ремонт',
  [RepairStatuses.REPAIR_FINISHED]: 'Работы завершены',
  [RepairStatuses.DISPATCHED]: 'Отгружен из СЦ',
  [RepairStatuses.CANCELED]: 'Отменен',
};

export const repair_statuses = Object.keys(
  RepairStatusesTranslate,
).map(
  (f: string) => ({ text: RepairStatusesTranslate[f], value: f as RepairStatuses }),
);
